export const dashBoardLabel = {
  name: "Dashboard",
  plural: "Dashboard",
  // Used in routes and navigation
  pathName: "",
  value: "dashboard",
};
